export const setConnector = () => {
  return {
    all_traffic_sources:
    //@ts-ignore
    document.getElementById('all_traffic_sources')?.value || '',
    //@ts-ignore
    browser: document.getElementById('browser')?.value || '',
    //@ts-ignore
    city: document.getElementById('city')?.value || '',
    //@ts-ignore
    country: document.getElementById('country')?.value || '',
    //@ts-ignore
    fc_campaign: document.getElementById('fc_campaign')?.value || '',
    //@ts-ignore
    fc_channel: document.getElementById('fc_channel')?.value || '',
    //@ts-ignore
    fc_content: document.getElementById('fc_content')?.value || '',
    //@ts-ignore
    fc_landing: document.getElementById('fc_landing')?.value || '',
    //@ts-ignore
    fc_medium: document.getElementById('fc_medium')?.value || '',
    //@ts-ignore
    fc_referrer: document.getElementById('fc_referrer')?.value || '',
    //@ts-ignore
    fc_source: document.getElementById('fc_source')?.value || '',
    //@ts-ignore
    fc_term: document.getElementById('fc_term')?.value || '',
    //@ts-ignore
    GA_Client_ID: document.getElementById('GA_Client_ID')?.value || '',
    //@ts-ignore
    gclid: document.getElementById('gclid')?.value || '',
    //@ts-ignore
    ip_address: document.getElementById('ip_address')?.value || '',
    //@ts-ignore
    region: document.getElementById('region')?.value || '',
    //@ts-ignore
    lc_campaign: document.getElementById('lc_campaign')?.value || '',
    //@ts-ignore
    lc_channel: document.getElementById('lc_channel')?.value || '',
    //@ts-ignore
    lc_content: document.getElementById('lc_content')?.value || '',
    //@ts-ignore
    lc_landing: document.getElementById('lc_landing')?.value || '',
    //@ts-ignore
    lc_medium: document.getElementById('lc_medium')?.value || '',
    //@ts-ignore
    lc_referrer: document.getElementById('lc_referrer')?.value || '',
    //@ts-ignore
    lc_source: document.getElementById('lc_source')?.value || '',
    //@ts-ignore
    lc_term: document.getElementById('lc_term')?.value || '',
    //@ts-ignore
    latitude: document.getElementById('latitude')?.value || '',
    //@ts-ignore
    longitude: document.getElementById('longitude')?.value || '',
    //@ts-ignore
    page_visits: document.getElementById('page_visits')?.value || '',
    //@ts-ignore
    OS: document.getElementById('OS')?.value || '',
    pages_visited_list:
    //@ts-ignore
    document.getElementById('pages_visited_list')?.value || '',
    //@ts-ignore
    time_passed: document.getElementById('time_passed')?.value || '',
    //@ts-ignore
    time_zone: document.getElementById('time_zone')?.value || '',
    //@ts-ignore
    device: document.getElementById('device')?.value || '',
  };
};
